import { ITransaction } from "../resources/interfaces";
import { TRANSACTION_STATUS, TRANSACTION_TYPE } from "../resources/enums";

export default class Transaction {
    id: number;
    reference: string;
    title: string;
    amount: number;
    description: string;
    type: string;
    status: string;
    fromCompanyId: number;
    fromCompanyName: string;
    fromLeg: string;
    toCompanyId: number;
    toCompanyName: string;
    toLeg: string;
    transactionDate: string;
    createdOn: string;
    updatedOn: string;


    constructor(data: ITransaction) {
        this.id = data.id;
        this.reference = data.reference;
        this.title = data.title;
        this.amount = data.amount;
        this.description = data.description;
        this.type = data.type;
        this.status = data.status;
        this.fromCompanyId = data.fromCompanyId;
        this.fromCompanyName = data.fromCompanyName;
        this.fromLeg = data.fromLeg;
        this.toCompanyId = data.toCompanyId;
        this.toCompanyName = data.toCompanyName;
        this.toLeg = data.toLeg;
        this.transactionDate = data.transactionDate;
        this.createdOn = data.createdOn;
        this.updatedOn = data.updatedOn;
    }

    isCompleted() {
        return this.status === TRANSACTION_STATUS.COMPLETED;
    }

    isPartial() {
        return this.status === TRANSACTION_STATUS.PARTIAL;
    }

    isProcessing() {
        return this.status === TRANSACTION_STATUS.PROCESSING;
    }

    isCancelled() {
        return this.status === TRANSACTION_STATUS.CANCELLED;
    }

    isFailed() {
        return this.status === TRANSACTION_STATUS.FAILED;
    }

    isDisbursement() {
        return this.type === TRANSACTION_TYPE.DISBURSEMENT;
    }

    isLoanDisbursement() {
        return this.type === TRANSACTION_TYPE.LOAN_DISBURSEMENT;
    }

    isWithdrawal() {
        return this.type === TRANSACTION_TYPE.WITHDRAWAL;
    }

    isLoanRepayment() {
        return this.type === TRANSACTION_TYPE.LOAN_REPAYMENT;
    }

    isDeposit() {
        return this.type === TRANSACTION_TYPE.DEPOSIT;
    }

    isPremiumPayment() {
        return this.type === TRANSACTION_TYPE.PREMIUM_PAYMENT;
    }

    isCommissionPayment() {
        return this.type === TRANSACTION_TYPE.COMMISSION_PAYMENT;
    }

    isTaxPayment() {
        return this.type === TRANSACTION_TYPE.TAX_PAYMENT;
    }

    isClaimPayment() {
        return this.type === TRANSACTION_TYPE.CLAIM_PAYMENT;
    }

    isServiceFee() {
        return this.type === TRANSACTION_TYPE.SERVICE_FEE;
    }

    isPlatformFee() {
        return this.type === TRANSACTION_TYPE.PLATFORM_FEE;
    }

    isAdjustment() {
        return this.type === TRANSACTION_TYPE.ADJUSTMENT;
    }

    isOther() {
        return this.type === TRANSACTION_TYPE.OTHER;
    }
}